import PropTypes from 'prop-types'
import MinimalHeader from '../shared/MinimalHeader'

/**
 * AiDashboardLayout Component
 *
 * Minimal layout for AI Dashboard
 * Clean interface focused on natural language queries
 * No location selector or filters - AI handles context
 */
function AiDashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <MinimalHeader title="AI Dashboard" icon="✨" />
      <main>{children}</main>
    </div>
  )
}

AiDashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AiDashboardLayout
